if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    constructor() {
      super();

      this.onCartUpdated = this.onCartUpdated.bind(this);
      this.onCartPubSubUpdate = this.onCartPubSubUpdate.bind(this);
      this.refreshCartState = this.refreshCartState.bind(this);
    }

    connectedCallback() {
      this.minimumAmount = Number(this.dataset.freeShippingMinimum || 0);
      if (!this.minimumAmount) return;

      this.trackElement = this.querySelector('.free-shipping__track');
      this.textElement = this.querySelector('[data-free-shipping-text]');
      this.progressElement = this.querySelector('[data-free-shipping-progress]');
      this.successTemplate = this.querySelector('[data-free-shipping-success-template]')?.innerHTML || '';
      this.remainingTemplate = this.querySelector('[data-free-shipping-remaining-template]')?.innerHTML || '';

      this.render(Number(this.dataset.cartTotal || 0));
      this.refreshCartState();

      document.addEventListener('cart:updated', this.onCartUpdated);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartPubSubUpdate);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
      this.cartUpdateUnsubscriber?.();
    }

    onCartUpdated(event) {
      const cart = event?.detail?.cart;
      if (!cart) {
        this.refreshCartState();
        return;
      }

      try {
        const parsedCart = typeof cart === 'string' ? JSON.parse(cart) : cart;
        if (typeof parsedCart.total_price === 'number') {
          this.render(parsedCart.total_price);
          return;
        }
      } catch (error) {
        return this.refreshCartState();
      }

      this.refreshCartState();
    }

    onCartPubSubUpdate(event = {}) {
      if (event.source === 'cart-items') return;
      this.refreshCartState();
    }

    refreshCartState() {
      if (this.refreshPromise) return this.refreshPromise;

      this.refreshPromise = fetch(`${theme.routes.cart_url}.js`, {
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => response.json())
        .then((cart) => {
          if (typeof cart.total_price === 'number') {
            this.render(cart.total_price);
          }
        })
        .catch(() => {
          return null;
        })
        .finally(() => {
          this.refreshPromise = null;
        });

      return this.refreshPromise;
    }

    render(totalPrice) {
      const currentTotal = Number(totalPrice || 0);
      const remainingAmount = Math.max(this.minimumAmount - currentTotal, 0);
      const progressPercent = this.minimumAmount > 0 ? Math.min((currentTotal / this.minimumAmount) * 100, 100) : 0;
      const isComplete = remainingAmount === 0;

      this.dataset.cartTotal = currentTotal;

      if (this.textElement) {
        if (isComplete) {
          this.textElement.innerHTML = this.successTemplate;
          this.textElement.classList.add('free-shipping__text--success');
        } else {
          this.textElement.innerHTML = this.remainingTemplate.replace('__remaining_amount__', this.formatMoney(remainingAmount));
          this.textElement.classList.remove('free-shipping__text--success');
        }
      }

      if (this.progressElement) {
        this.progressElement.style.setProperty('--progress', `${progressPercent}%`);
        this.progressElement.classList.toggle('free-shipping__progress--success', isComplete);
      }

      if (this.trackElement) {
        this.trackElement.style.setProperty('--progress', `${progressPercent}%`);
      }
    }

    formatMoney(cents) {
      const useCurrencyCode = Boolean(theme?.shopSettings?.currencyCode);
      const moneyFormat = useCurrencyCode
        ? theme?.shopSettings?.moneyWithCurrencyFormat
        : theme?.shopSettings?.moneyFormat;

      if (theme?.Currency?.formatMoney && moneyFormat) {
        return theme.Currency.formatMoney(cents, moneyFormat);
      }

      return (Number(cents) / 100).toFixed(2);
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}
